import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { PaginatedRepository } from '../pagination/paginated.repository';
import { ToastrService } from "ngx-toastr";
import { REG_HUB_COMMON_CONFIG, RegHubCommonConfig } from '../../reg-hub-common-config';
import { BundleOrderGroup } from '../../interfaces/bundle-order-groups/bundle-order-group';
import { BundleOrderGroupForCreation } from '../../interfaces/bundle-order-groups/bundle-order-group-for-creation';

@Injectable({
  providedIn: 'root'
})
export class BundleOrderGroupsRepositoryService extends PaginatedRepository<BundleOrderGroup> {
  protected override _baseLink: string;

  constructor(
    http: HttpClient,
    messageService: ToastrService,
    @Inject(REG_HUB_COMMON_CONFIG) private config: RegHubCommonConfig) {
    super(
      http,
      messageService);

    this._baseLinkTemplate = `${this.config.rootUrl}/Corporations/[0]/Bundles/[1]/OrderGroups`;
    this._baseLink = `${this.config.rootUrl}/Corporations/[0]/Bundles/[1]/OrderGroups`;
  }

  private generateHeaders = () => {
    return {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
  }

  public createBundleOrderGroup = (corporationID: string, bundlieID: string, bundleOrderGroup: BundleOrderGroupForCreation) => {
    this.populateBaseLink([corporationID, bundlieID]);

    return this.http.post(this._baseLink, bundleOrderGroup);
  }

  public createBundleOrderGroups = (corporationID: string, bundlieID: string, bundleOrderGroups: BundleOrderGroupForCreation[]) => {
    this.populateBaseLink([corporationID, bundlieID]);

    return this.http.post(`${this._baseLink}/Batch`, bundleOrderGroups);
  }

  public deleteBundleOrderGroup = (corporationID: string, bundlieID: string, bundleOrderGroupID: string) => {
    this.populateBaseLink([corporationID, bundlieID]);

    return this.http.delete(`${this._baseLink}/${bundleOrderGroupID}`);
  }
}
